import { UserMemo, UserMemoFromJSON, UserNote, UserNoteFromJSON } from '@/api'

export interface UserOfMemosAndNotes {
  memos: UserMemo[]
  notes: UserNote[]
}

export function UserOfMemosAndNotesFromJSON(json: any): UserOfMemosAndNotes {
  return UserOfMemosAndNotesFromJSONTyped(json)
}

export function UserOfMemosAndNotesFromJSONTyped(
  json: any
): UserOfMemosAndNotes {
  return {
    memos: json.memos.map(UserMemoFromJSON),
    notes: json.notes.map(UserNoteFromJSON)
  }
}

export const defaultUserOfMemosAndNotes = (): UserOfMemosAndNotes => ({
  memos: [],
  notes: []
})
